import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-summary-preview',
  templateUrl: './participant-summary-preview.component.html',
  styleUrls: ['./participant-summary-preview.component.css']
})
export class ParticipantSummaryPreviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
